import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import { GetUserSSODetailsInput, GetUserSSODetailsResponse } from './user-management-interface';

export const getUserSSODetails = async (
  input: GetUserSSODetailsInput,
): Promise<GetUserSSODetailsResponse> => {
  const data = await API.post(API_SERVICES.USER_MANAGEMENT_API, `/open/sso-details`, {
    headers: {
      'Content-Type': 'application/json',
    },
    data: input,
  });

  return data.data;
};
